<div class="container-fluid px-3">
    <app-update-customer [customerDataInput]="customerData"></app-update-customer>
    <app-assign-plan [customerDataInput]="customerData"></app-assign-plan>
    <app-list-customer-plans [customerDataInput]="customerData"></app-list-customer-plans>
  </div>